import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline, CircularProgress, Box } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react';
import { UserDataStoreContext } from './store';
import IntegrationsGrid from './components/IntegrationsGrid';
import Login from './components/Login';
import Dashboard from "./components/G2/Dashboard";
import DemandbaseDashboard from "./components/Demandbase/Dashboard";

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

// Verifies the SSO session with the backend on first render. Without a session the
// browser goes straight to the identity provider — there is no local sign-in screen to
// show (the /login route is only reached after logout or a failed callback).
const PrivateRoute = observer(({ children }) => {
  const userDataStore = React.useContext(UserDataStoreContext);

  React.useEffect(() => {
    if (!userDataStore.isResolved) {
      userDataStore.fetchMe();
      return;
    }
    if (!userDataStore.isAuthenticated) {
      userDataStore.login();
    }
  }, [userDataStore, userDataStore.isResolved, userDataStore.isAuthenticated]);

  if (!userDataStore.isResolved || !userDataStore.isAuthenticated) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', padding: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return children;
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <AppBar position="static">
          <Toolbar>
            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Integrations Platform
            </Typography>
            <Button color="inherit" component={Link} to="/integrations">
              Home
            </Button>
          </Toolbar>
        </AppBar>

        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/"
            element={
              <PrivateRoute>
                <IntegrationsGrid />
              </PrivateRoute>
            }
          />
          <Route
            path="/integrations"
            element={
              <PrivateRoute>
                <IntegrationsGrid />
              </PrivateRoute>
            }
          />
          <Route
            path="/integrations/g2"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
              path="/integrations/demandbase/*"
              element={
                <PrivateRoute>
                  <DemandbaseDashboard />
                </PrivateRoute>
              }
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default observer(App);
